import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { EmptyClientContactPerson } from "../clientContactPerson/EmptyClientContactPerson";
import { IClientContactPerson } from "../../models/ClientContactPerson";
import { ClientContact } from "./ClientContact";
import { Fetch } from "../../shared/Fetch";

const schema = yup.object({
    email: yup.string().email("Invalid Email*").required("Client Email is required*"),
    body: yup.string().nullable()
});

interface IOtherSource {
    email: string,
    body: string
}

interface Iprops {
    onCompose: (_data: { subject: string, body: string }, _email: string) => void,
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export const OtherSource = (props: Iprops) => {
    const [data, setData] = useState({ email: '', body: '' } as { email: string, body: string });
    const [loading, setLoading] = useState(false);

    const [client, setClient] = useState({ singleData: EmptyClientContactPerson, open: false } as { singleData: IClientContactPerson, open: boolean });
    const hideClient = () => {
        setClient({ singleData: EmptyClientContactPerson, open: false });
        setLoading(false);
    }

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IOtherSource>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onHide = () => {
        props.hideDialog();
        reset({});
        setData({ email: '', body: '' });
        setLoading(false);
    }

    async function onSubmit(_data: IOtherSource) {
        if (data.body.length < 1) props.toast.current.show({ severity: 'error', detail: "Content is Required.", life: 3000 });
        else {
            setLoading(true);
            setData(prev => ({ ...prev, email: _data.email }));
            const res = await Fetch('Sub_Vendor_Contact_Person_Mast/getClientAvailabilityByEmail', 'GET', null, `email_id=${0}&email=${_data.email}`, props.toast);
            if (res) {
                const contactPersonDetails: {
                    contact_Person_ID: number,
                    contact_Person_Name: string,
                    contact_Person_EmailID: string,
                    vendor_Company_ID: number,
                    vendor_Company_Name: string,
                    sales_Person_Id: number,
                    isMine: boolean,
                    message?: string
                } = await res.json();

                if (contactPersonDetails.message === 'Add Client') {
                    setClient(prev => ({ open: true, singleData: { ...prev.singleData, contact_Person_EmailID: _data.email, contact_Person_Name: '' } }));

                    return;
                }
                props.onCompose({ subject: '', body: data.body }, _data.email);
                onHide();
            }
        }
    }

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Compose Requirement from Raw Content" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput required label="Client Contact Person Email" control={control} name="email" error={errors.email?.message} />
                    <div className="col-12 md:col-12 md:col-6 mb-3">
                        <label htmlFor="body">Content (paste your job details bellow)</label>
                        <JVSunEditor name="body" value={data.body} handleChange={(d) => setData(prev => ({ ...prev, body: d }))} />
                    </div>

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                        <Button loading={loading} style={{ width: '200px' }} label="Compose Requirement" type="submit"></Button>
                        <Button style={{ width: '100px' }} label="CANCLE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </Dialog>
            <ClientContact singleData={client.singleData} open={client.open} hideDialog={hideClient} toast={props.toast} onSuccess={() => { props.onCompose({ subject: '', body: data.body }, data.email); onHide(); }} />
        </>
    );
}
